import { inject, Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

import { Auth, GoogleAuthProvider, authState, signOut, signInWithPopup, OAuthProvider } from '@angular/fire/auth';

import { Firestore, doc, onSnapshot } from '@angular/fire/firestore';

// Dialog popups
import { MatDialog } from '@angular/material/dialog';


// Custom services
import { UtilsService } from '../utils/utils.service';
import { LanguageService } from '../language/language.service';
import { HttpService } from '../http/http.service';
import { FirestoreService } from './firestore.service';


// Cloud function strings (environment dependent)
import { environment } from '../../../environments/environment';



@Injectable({
  providedIn: 'root'
})
export class UserAuthenticationService {

  private auth = inject(Auth);
  private googleAuth = inject(GoogleAuthProvider)
  private firestore = inject(Firestore);

  // Observable that indicates if the user is logged in or not to other services or components
  private userIsLoggedBehaviorSubject: BehaviorSubject<boolean> ;
  // Observable value of nRemainingAnalysis
  private nRemainingAnalysisBehaviorSubject: BehaviorSubject<number> ;


  // Custom variables to control the user state
  private _currentUser:any = null;
  private _userLicenseDict:any = {};
  private _userKeyCodeOnChangeListenerSubscription:any = null;
  private _userLicenseOnChangeListenerSubscription:any = null;


  constructor(
    public dialog:MatDialog,
    public utilsService:UtilsService,
    public languageService:LanguageService,
    public httpService:HttpService,
    public firestoreService:FirestoreService, 
  ) {
    // Observable that indicates if the user is logged in or not to other services or components
    this.userIsLoggedBehaviorSubject = new BehaviorSubject<boolean>(false);
    // Observable value of nRemainingAnalysis
    this.nRemainingAnalysisBehaviorSubject = new BehaviorSubject<number>(0);
    // Link the observable with the user logged value (authenticated / unauthenticated)
    authState(this.auth).subscribe(user => {
     if (!user){
      this.setUserIsLoggedValue(false);
     }
    });
   }

  
  // ----- Firestore on change listener ----- //
 



  // ------ User is logged observable ----//

  // Methods to subscribe to user logged value
  setUserIsLoggedValue(newValue:boolean): void {
    this.userIsLoggedBehaviorSubject.next(newValue);
  }
  getUserIsLoggedValue(): Observable<boolean> {
    return this.userIsLoggedBehaviorSubject.asObservable();
  }

  // Methods for updating the observable value of nRemainingAnalysis
  setNRemainingAnalysisValue(newValue:number): void {
    this.nRemainingAnalysisBehaviorSubject.next(newValue);
  }
  getNRemainingAnalysisValue(): Observable<number> {
    return this.nRemainingAnalysisBehaviorSubject.asObservable();
  }



  // ------ Methods to access privat evariables ------ //

  // User  Id Token
  async getUserIdToken() {
    const user = await this.auth.currentUser;
    if (user) {
      const idToken = await user.getIdToken();
      return idToken;
    }
    return '';
  }

  // User Id
  getUserId(){
    return this._currentUser.uid
  }

  // User email
  getUserEmail(){
    return this._currentUser.email
  }

  // User license dict
  getUserLicenseDict(){
    const licensesList = Object.entries(this.languageService.Strings.processesString).map(([key, name]) => ({key, name,}));
    this._userLicenseDict['licenses'] = licensesList;
    return this._userLicenseDict
  }








  // ----- Popups ----- //


  
  // // Send verification email popup open
  // emailVerificationPopupComponent(currentUser:any){
  //   this.dialog.open(
  //     EmailVerificationPopupComponent, 
  //     {
  //       disableClose: true,
  //       data: {currentUser:currentUser},
  //       //width: '500px',  // Ajusta el ancho a tu necesidad
  //       //height: '500px', // Ajusta la altura a tu necesidad
  //     } 
  //   ).afterClosed().subscribe(result => this.shouldSendVerificatoinEmail(result))
  // }
  // // Send verification email popup closed
  // shouldSendVerificatoinEmail(result:any){
  //   if(result.shouldSendVerificationEmail){
  //     // Try to send reset password email
  //     sendEmailVerification(result.currentUser).then(() => {
  //       // Notify the user that the email has been sent
  //       let infoMessage = this.languageService.Strings.authentication.resetPasswordemail_sent + result.currentUser.email
  //       this.utilsService.displayCustomSnackBar(infoMessage)
  //     }).catch((error:any) => {
  //       // TODO: TBD -- Manage error     
  //     })
  //   }
  // }

  async login(provider:string){
    try{
      if(provider === 'google'){
        let result = await signInWithPopup(this.auth, this.googleAuth)
        // Store the current user information
        this._currentUser = result.user       
      }else{
        return {resultOk:false, error:'Wrong provider'}
      }
      // Set user as logged
      this.setUserIsLoggedValue(true); 
      // Return ok to close the login popup
      return {resultOk:true}
    }catch(error) {
      console.log(error)
      return {resultOk:false, error:error}
    }
  }



}
